/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_82939044"]'><cube-modal ref="__mpx_ref_modal__" type="confirm" title="我是标题~" content="我是正文正文" confirm-btn="一个按钮" :mask-closable="(true)" @maskClick='(e)=>__invoke(e, [["onMaskClick"]])' @confirm='(e)=>__invoke(e, [["onConfirm"]])' @cancel='(e)=>__invoke(e, [["onCancel"]])'/><cube-button @_click="onTap">modal-one-button</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_82939044"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_82939044"}
  /** script content **/
  require("./modal-one-btn.mpx.js?isComponent&outputPath=components%2Fmodal-one-btn82939044%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./modal-one-btn.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fmodal-one-btn82939044%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_82939044"],
    ctorType: "component",
    outputPath: "components/modal-one-btn82939044/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/modal/index.mpx?isComponent&outputPath=components%2Findex317b3b4c%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>